import { render, staticRenderFns } from "./GameModal.vue?vue&type=template&id=4d3ffd7a&scoped=true"
import script from "./GameModal.vue?vue&type=script&lang=js"
export * from "./GameModal.vue?vue&type=script&lang=js"
import style0 from "./GameModal.vue?vue&type=style&index=0&id=4d3ffd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ffd7a",
  null
  
)

export default component.exports